import React, { useContext, useState,PureComponent } from 'react'
import toast, { Toaster } from 'react-hot-toast';
import Input from '../components/forms/Input';
import Button from '../components/forms/Button';
import { initializeApp } from "firebase/app";
import {setToLocalStorage} from '../components/helper/auth'
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    signOut,
    sendEmailVerification,
    sendSignInLinkToEmail,
} from "firebase/auth";
import {
    getFirestore,
    query,
    getDocs,
    collection,
    where,
    addDoc,
} from "firebase/firestore";
import { firebaseConfig } from "../firebaseConfig"
import { AuthContext } from '../context/auth';
import { useNavigate,Link } from 'react-router-dom';

export default function ForgotPassword() {
  
    const [authc, setAuth] = useContext(AuthContext);
    console.log(authc)
    const [email, setEmail] = useState("");
    
    const navigate=useNavigate();
    const app = initializeApp(firebaseConfig);
    const auth = getAuth();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
      e.preventDefault();
      setLoading(true)
      try {      
        var actionCodeSettings = {
          url: 'http://localhost:3000/rest',
          handleCodeInApp: true,
        }
          sendSignInLinkToEmail(auth, email,actionCodeSettings).then(async (userCredential) => {
              toast.success("Password Reset link sent to email")
              window.localStorage.setItem('emailForSignIn', email);
              setTimeout(()=>{
                  navigate('/login')
              },2000)
              
          }).catch((error) => {
            setLoading(false)
              
              
              setTimeout(()=>{
                // navigate('/register')
            },2000)
              const errorCode = error.code; 
              const errorMessage = error.message;
              console.log(errorCode)
              if(errorCode=='auth/network-request-failed'){
                toast.error("check network ")
              }else toast.error(errorMessage)
          });
      } catch (error) {
          setLoading(false)
          console.log(error);
      }
  }
    return (

      <div style={{ margin: "100px" }} className='d-flex justify-content-center align-items-center vh-100' >
          <Toaster />
          <div className='container'>
              <div className='row'>
                  <div className='col-md-6 offset-md-3'>
                      <h1 className='fw-bold mb-3'>Forgot password</h1>

                      <form>
                          <Input value={email} setValue={setEmail} label="Email" type="email" />
                          <Button handleSubmit={handleSubmit} 
                                    className={"btn btn-primary" }
                                    type={"submit"}
                                    text={"Submit"}
                                    email={email}
                                    
                                    loading={loading}/>
                      </form>
                      <p className='mt-3'><Link to={"/forgot-password"}>Forgot password</Link> </p> 
                  </div>

              </div>

          </div>

          <pre>                       {JSON.stringify({ email}, null, 4)}</pre>

      </div>
  )

  }

